import {ColumnsVisibilityMenu} from '../../tickets/components/ColumnsVisibilityMenu';
import {DASHBOARD_TOGGLEABLE_COLUMNS, type DashboardColumnKey} from '../constants/dashboardColumns';

interface Props {
	isVisible: (key: DashboardColumnKey) => boolean;
	onToggle: (key: DashboardColumnKey) => void;
}

/**
 * The dashboard's show/hide columns menu. Hidden below 1280px, which is the
 * viewport the single-row toolbar is specified for (PRD §6.2) — below it the
 * toolbar wraps and the table is not in its full-width form.
 */
export function DashboardColumnsToggle({isVisible, onToggle}: Props) {
	return (
		<ColumnsVisibilityMenu
			columns={DASHBOARD_TOGGLEABLE_COLUMNS}
			isVisible={isVisible}
			onToggle={onToggle}
			hideBelowPx={1280}
			data-testid="dashboard-columns-toggle"
		/>
	);
}
